import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";
import type { SubcontractorMaster } from "../types";

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

export async function fetchSubcontractorMasters(): Promise<SubcontractorMaster[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/subcontractor-masters`);
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<SubcontractorMaster[]>;
}

export async function createSubcontractorMasterApi(
  row: Omit<SubcontractorMaster, "id" | "createdAt">,
): Promise<SubcontractorMaster> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/subcontractor-masters`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(row),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<SubcontractorMaster>;
}

export async function updateSubcontractorMasterApi(
  id: string,
  patch: Partial<Omit<SubcontractorMaster, "id" | "createdAt">>,
): Promise<SubcontractorMaster> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/subcontractor-masters/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<SubcontractorMaster>;
}

export async function deleteSubcontractorMasterApi(id: string): Promise<void> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/subcontractor-masters/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(await parseError(res));
}
